export const SAVE_TEMPORARY_VALUE = "SAVE_TEMPORARY_VALUE"
export const CLEAR_TEMPORARY_VALUE = "CLEAR_TEMPORARY_VALUE"
